import React from "react";
import NavBar from "../NavBar";
import HumanizeTexts from "../humanize_texts/HumanizeTexts";
import HowToHumanize from "../humanize_texts/HowToHumanize";
import SectionWhatIsHumanizerQA from "../humanize_texts/SectionWhatIsHumanizerQA";
import SectionAIDetect from "../humanize_texts/SectionAIDetect";
import SectionAdvantageQA from "../humanize_texts/SectionAdvantageQA";
import SectionWhoCanBenefit from "../humanize_texts/SectionWhoCanBenefit";
import Footer from "../Footer";
import { analytics } from "../../App";
import { logEvent } from "firebase/analytics";

function HumanizeTextsMain() {
  return (
    <div className="p-3">
      {/*Firebase analytics */}
      {logEvent(analytics, "Humanize Texts Screen")}

      {/*Add title and metadata */}
      <title>Humanize AI Text: Free AI Humanizer Tool (100% Accuracy)</title>
      <meta name="robots" content="index, follow"></meta>
      <link rel="canonical" href="https://humanizetexts.com/" />
      <meta
        name="description"
        content="Rewrite AI written texts (ChatGPT, Gemini, Copilot, Perplexity etc) into more human like formats. Bypass all AI detectors like QuillBot, Originality.AI, GPTZero, Undetectable.ai."
      ></meta>
      <meta
        name="keywords"
        content="humanizer,humanize,ai to humanizer,humanize ai texts,free ai humanizer tool,humanize ai,free ai humanizer,100% accuracy,undetectable ai,zero ai,"
      ></meta>
      <meta
        property="og:title"
        content="Humanize AI Text: Free AI Humanizer Tool (100% Accuracy)"
      />
      <meta
        name="twitter:title"
        content="Humanize AI Text: Free AI Humanizer Tool (100% Accuracy)"
      ></meta>
      
      {/* NavBar component */}
      <NavBar />
      {/* top heading */}
      <HumanizeTexts />
      {/* How to humanize text */}
      <HowToHumanize />
      {/*what is humanize text */}
      <SectionWhatIsHumanizerQA />
      {/* Ai detect*/}
      <SectionAIDetect />
      {/* Advantages of Humanizing Text */}
      <SectionAdvantageQA />
      {/* Who can benefit */}
      <SectionWhoCanBenefit />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default HumanizeTextsMain;
